const INITIAL_STATE = {
    error: false,
    loading: null,
    data: []
}

const GetPlatforms = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'GET_PLATFORMS_REQUEST':
            return { loading: true, error: false, data: [] }
        case 'GET_PLATFORMS_ERROR':
            return { loading: false, error: true, data: [] };
        case 'GET_PLATFORMS_SUCCESS':
            return { loading: false, error: false, data: action.payload };
        case 'GET_PLATFORMS_RESET':
            return { loading: false, error: false, data: [] };
        default:
            return state;
    }
}

export default GetPlatforms 